import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import config from '../../config';

const NAME = config.name;

const PageHelpDisableBlocker: FC = () => {
   return (
      <div className="container">
         <Helmet>
            <title>{config.SEO.blocker_help.title}</title>
         </Helmet>
         <article className="main-column">
            <header>
               <h1>How can I disable my ad blocker to support {NAME}?</h1>
            </header>
            <div>
               <p>
                  The ads help {NAME} keep the site free. We do our best at
                  {NAME} to ensure that the ads do not interfere with your color
                  selection experience.
               </p>
               <p>
                  If you would like to support our mission of free sharing, we
                  ask that you disable your ad blockers from our website and
                  applications.
               </p>
               <p>
                  Most ad blockers have an option to turn off ad blocking and we
                  suggest that you add {NAME} to the list of supported sites in
                  your blocker settings.
               </p>
               <p>
                  If you use Google Chrome, here are the instructions on how to
                  disable AdBlock, Adblocker Ultimate or AdBlock Plus:
               </p>
               <h1>&nbsp;</h1>
               <h1>
                  <span>AdBlock</span>
               </h1>
               <ol>
                  <li>
                     <span>
                        Opens the AdBlock menu at the top right of the browser.
                     </span>
                  </li>
                  <li>
                     <span>Click "Do not run on pages of this site".</span>
                  </li>
                  <li>
                     <span>AdBlock will not run in {NAME}.</span>
                  </li>
               </ol>
               <h1>&nbsp;</h1>
               <h1>
                  <span>AdBlocker Ultimate</span>
               </h1>
               <ol type="A">
                  <li>
                     <span>
                        Opens the AdBlocker Ultimate menu at the top right of
                        the browser.
                     </span>
                  </li>
                  <li>
                     <span>Click "Activated on this page".</span>
                  </li>
                  <li>
                     <span>Reload the page</span>
                  </li>
                  <li>
                     <span>
                        AdBlocker Ultimate will no longer run on {NAME}
                     </span>
                  </li>
               </ol>
               <h1>&nbsp;</h1>
               <h1>
                  <span>
                     AdBlock Plus
                     <br />
                  </span>
               </h1>
               <ol>
                  <li>
                     <span>
                        Opens the Adblock Plus menu at the top right of the
                        browser.
                     </span>
                  </li>
                  <li>
                     <span>Click on "Activated on this site".</span>
                  </li>
                  <li>
                     <span>Reload the page.</span>
                  </li>
                  <li>
                     <span>AdBlocker Plus will no longer run in {NAME}.</span>
                  </li>
               </ol>
               <br />
               <br />
               <p style={{ textAlign: 'center' }}>
                  All rights reserved &copy; <a href="/">{NAME}</a>
               </p>
            </div>
         </article>
         <style jsx>{`
            .main-column {
               max-width: 750px;
               margin: auto;
               padding: 50px 0 150px 0;
               :global(ol) {
                  list-style-type: decimal !important;
               }
            }
         `}</style>
      </div>
   );
};

export default PageHelpDisableBlocker;
